/* --- - Fixing SP menu for different devices - October 14, 2024 ----------------------------- */
function adjustMenuMobilePosition() {
  const csSlide = document.getElementById('cs-slide');
  const csHeader = document.getElementById('cs-header');
  const csMenuMobile = document.getElementById('cs-menuMobile');

  if (csSlide && csHeader && csMenuMobile) {
    const slideHeight = csSlide.offsetHeight;
    const headerHeight = csHeader.offsetHeight;
    const totalHeight = slideHeight + headerHeight - 34;  // Subtract 34px from the total height

    // Check if the screen width is between 320px and 480px (for mobile devices)
    if (window.matchMedia("(min-device-width: 320px) and (max-device-width: 480px)").matches) {
      // Set the top value to the adjusted total height
      csMenuMobile.style.top = totalHeight + 'px';
    } else {
      // Reset the top value if the device width is outside the mobile range
      csMenuMobile.style.top = 'initial';
    }
  }
}

// Call the function on page load and when the window is resized
window.addEventListener('load', adjustMenuMobilePosition);
window.addEventListener('resize', adjustMenuMobilePosition);
